import React, {Fragment} from 'react';

import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import _isEqual from "lodash/isEqual";
import {connect, MapDispatchToProps, MapStateToProps} from "react-redux";
import {addCreditCard} from "../../../vendors/actions/creditCard";
import NewCard from "./newCard";
import {FormHelperText, InputAdornment} from "@material-ui/core";

interface OwnProps {
    addCreditCard?: any

    [key: string]: any
}

interface MainState {
    user: any,
    newCard: boolean,
    loggedIn: boolean
}

interface ConnectStateProps {
    User: any
    CreditCardForm: any
}

interface ConnectDispatchProps {
    addCreditCard?: (data: any) => void;
}

type HeaderProps = OwnProps & ConnectStateProps & ConnectDispatchProps;


class CreditCardForm extends React.Component<HeaderProps, MainState> {
    state = {
        user: {
            paymentMethods: {
                id: null,
                card: {
                    brand: '',
                    last4: ''
                }
            }
        },
        loggedIn: false,
        newCard: false,
    };



    componentDidMount() {
        const {User} = this.props;
        const {user:{ paymentMethods}} = this.state;
        this.setState({
            user: User,
            loggedIn: Object.keys(User).length > 0
        });
        paymentMethods && this.selectCard()
    }

    static getDerivedStateFromProps(props: any, state: any) {
        const {User} = props;
        if (Object.keys(User).length && (!_isEqual(state.user, User))) {
            return {
                user: User,
                loggedIn: true
            }
        }
        return null;
    }

    selectCard = () => {
        const {user: {paymentMethods}} = this.state;

        this.props.addCreditCard({value: null, field: 'number'});
        this.props.addCreditCard({value: null, field: 'exp_month'});
        this.props.addCreditCard({value: null, field: 'exp_year'});
        this.props.addCreditCard({value: null, field: 'cvc'});
        this.props.addCreditCard({value: paymentMethods.id, field: 'paymentMethod'});
        this.setState({newCard: false});
    };

    setNewCard = () => {
        this.props.addCreditCard({value: null, field: 'paymentMethod'});
        this.setState({newCard: true})
    };


    render() {
        const {user:{paymentMethods}, loggedIn, newCard} = this.state;
        const {CreditCardForm} = this.props;

        const oldCardBrand = (paymentMethods?.card?.brand || 'unknown').toLowerCase().replace(" ", "");

        return (
            <Fragment>
                {
                    loggedIn ?
                        <Fragment>
                            {paymentMethods?.id ?
                                <Fragment>
                                    <RadioGroup defaultValue="old" aria-label="Credit Card"
                                                className={'credit-card-radios'} name="credit-card-radios">
                                        <FormControlLabel
                                            className={`card-number ${!newCard ? 'selected' : ''} grey-text text-field-custom-mb`}
                                            value="old"
                                            onClick={this.selectCard}
                                            control={<Radio color="primary"/>}
                                            label={<div className={'d-flex align-items-center'}>
                                                <InputAdornment position="start">
                                                <span
                                                      className={`card-icon-holder card-icon-${oldCardBrand}`}/></InputAdornment>
                                                <div>**** **** **** {paymentMethods?.card?.last4}</div>
                                            </div>
                                            }/>
                                        <FormControlLabel
                                            className={`card-number ${newCard ? 'selected text-field-custom-mb' : ''} grey-text`}
                                            value="new"
                                            onClick={this.setNewCard}
                                            control={<Radio color="primary"/>}
                                            label={<div className={'d-flex align-items-center'}>
                                                <InputAdornment position="start">
                                                <span className={`card-icon-holder card-icon-unknown`}/></InputAdornment>
                                                <div>Add another Card</div>
                                            </div>
                                            }/>
                                    </RadioGroup>
                                    {newCard && <NewCard/>}
                                </Fragment> : <NewCard/>}
                        </Fragment> :
                        <NewCard/>
                }
                {!!CreditCardForm.apiError && <FormHelperText className={'mt-1 text-left'} error={!!CreditCardForm.apiError}>{CreditCardForm.apiError}</FormHelperText>}
            </Fragment>
        )
    }
}

type ConnectStateMapper = MapStateToProps<ConnectStateProps, OwnProps>

const mapStateToProps: ConnectStateMapper = (state: any) => {
    const {User, CreditCardForm} = state;
    return {
        User,
        CreditCardForm
    }
};

type ConnectDispatchMapper = MapDispatchToProps<ConnectDispatchProps, OwnProps>

const mapDispatchToProps: ConnectDispatchMapper = (dispatch: any) => {
    return {
        addCreditCard: (data: any) => dispatch(addCreditCard(data)),
    }
};


export default connect(mapStateToProps, mapDispatchToProps)(CreditCardForm);
